import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ProductsContextProvider from './components/Context/CounterStore.js';
import { AuthProvider } from './components/Context/Auth.js';
import { ProductProvider } from './components/Context/ProductContext.js';
import { CartProvider } from './components/Context/Cart.js';
import { HashRouter } from 'react-router-dom';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

 <HashRouter>
 <CartProvider>
 <ProductProvider>
 <AuthProvider>
    <ProductsContextProvider>
      <App />
    </ProductsContextProvider>
  </AuthProvider>
  </ProductProvider>
  </CartProvider>
 </HashRouter>
  
 
 
);



reportWebVitals();
